import {useEffect, useState} from 'react';
import axios from 'axios';

const GOOGLE_API_KEY = 'AIzaSyDVSjKMr1sGNq7dlzGm3YBskX9GYeZJ5Uk';

export const districtImages = {
  Spitalfields:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Spitalfields_e6deca4885.jpeg?updated_at=2023-04-07T17:23:54.880Z',
  "St Katharine's & Wapping":
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/St_Katharine_Docks_summer_smaller_1_939d43ef04.jpeg?updated_at=2023-04-07T17:24:11.262Z',
  'Bethnal Green':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Bethnal_Green_5ee2a65a9d.jpeg?updated_at=2023-04-07T17:23:50.484Z',
  Bow: 'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Bow_afb4bd8889.jpeg?updated_at=2023-04-07T17:24:11.605Z',
  Chingford:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/chingford_1_3ac1573d1d.jpeg?updated_at=2023-04-07T17:24:09.855Z',
  Clapton:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/clapton_d07982acce.jpeg?updated_at=2023-04-07T17:23:57.699Z',
  'East Ham':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/East_Ham_e3a820f097.jpg?updated_at=2023-04-07T17:24:11.132Z',
  'Forest Gate':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Forest_Gate_c109916b08.jpeg?updated_at=2023-04-07T17:24:08.827Z',
  Hackney:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Hackney_470958de8a.avif?updated_at=2023-04-07T17:24:10.885Z',
  Homerton:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/homerton_87c5b56294.jpeg?updated_at=2023-04-07T17:24:23.340Z',
  Leyton:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Leyton_96f1913273.jpeg?updated_at=2023-04-07T17:23:50.582Z',
  Leytonstone:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/leytonstone_5a9440dc4d.jpeg?updated_at=2023-04-07T17:24:12.343Z',
  'Manor Park':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Manor_Park_52ca932002.jpeg?updated_at=2023-04-07T17:24:04.732Z',
  Plaistow:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Plaistow_8b597f2eb5.jpeg?updated_at=2023-04-07T17:24:13.688Z',
  'Canary Wharf':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/cnary_wharfe_f56f01180f.webp?updated_at=2023-04-07T17:24:03.934Z',
  Stratford:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Stratford_6cec70ab27.jpeg?updated_at=2023-04-07T17:24:11.475Z',
  'Victoria Docks and North Woolwich':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/victoria_docks_e79008bb17.png?updated_at=2023-04-07T17:24:25.597Z',
  Walthamstow:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/walthamstow_b5788052ca.jpeg?updated_at=2023-04-07T17:24:13.212Z',
  'Woodford and South Woodford':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/woodford_58ad3265cf.jpeg?updated_at=2023-04-07T17:24:24.364Z',
  'Olympic Park':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Olympic_park_048943eb49.jpeg?updated_at=2023-04-07T17:24:22.873Z',
  Bishopsgate:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Bishopgate_115912e203.jpg?updated_at=2023-04-07T17:22:08.036Z',
  'Fenchurch Street':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Fenchurch_Street_659a50623e.jpeg?updated_at=2023-04-07T17:24:23.731Z',
  'Fleet Street':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/fleet_street_b666431a6d.jpeg?updated_at=2023-04-07T17:24:21.863Z',
  Islington:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/islington_743f6e7245.jpeg?updated_at=2023-04-07T17:24:21.453Z',
  'Camden Town':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/camden_town_e371ff7265.jpeg?updated_at=2023-04-07T17:24:12.888Z',
  Hampstead:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/hampstead_ca500b1ae1.jpeg?updated_at=2023-04-07T17:24:13.349Z',
  "St John's Wood":
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/St_Johns_Wood_48d06f3bb3.jpeg?updated_at=2023-04-07T17:24:22.367Z',
  'Elephant and Castle':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/elephant_and_castle_7c05d36e3b.jpeg?updated_at=2023-04-07T17:24:04.958Z',
  Greenwich:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Greenwich_97736a14d1.jpeg?updated_at=2023-04-07T17:24:17.704Z',
  Chelsea:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/chelsea_549aa42111.jpeg?updated_at=2023-04-07T17:24:20.612Z',
  Brixton:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/brixton_a99dbf49a2.jpeg?updated_at=2023-04-07T17:24:08.263Z',
  Clapham:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/clapham_97468a54dc.avif?updated_at=2023-04-07T17:24:15.029Z',
  'Earls Court':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/earl_s_court_f94858f463.jpeg?updated_at=2023-04-07T17:24:19.529Z',
  Fulham:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/fulham_0b9e36e492.jpeg?updated_at=2023-04-07T17:24:24.355Z',
  'South Kensington':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/South_Kensington_7827e69608.jpeg?updated_at=2023-04-07T17:24:07.068Z',
  'South Lambeth':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/brixton_a99dbf49a2.jpeg?updated_at=2023-04-07T17:24:08.263Z',
  Wimbledon:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Wimbledon_0ed26f02c4.jpeg?updated_at=2023-04-07T17:24:15.179Z',
  Paddington:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/paddington_505e33fcde.jpeg?updated_at=2023-04-07T17:24:06.487Z',
  Chiswick:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/chiswick_925f227fc0.avif?updated_at=2023-04-07T17:24:16.929Z',
  Hammersmith:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/hammersmith_6e3d3b66d7.jpeg?updated_at=2023-04-07T17:24:22.838Z',
  'Hanwell Kensington':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/South_Kensington_7827e69608.jpeg?updated_at=2023-04-07T17:24:07.068Z',
  'Maida Hillgton':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/north_kensington_9004893bce.jpeg?updated_at=2023-04-07T17:24:18.220Z',
  'Notting Hill':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/notting_hill_london_portobello_market_b6104bfa9f.jpeg?updated_at=2023-04-07T17:24:07.316Z',
  'Shepherds Bush':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Shepherd_s_Bush_0c2bed553c.jpeg?updated_at=2023-04-07T17:24:20.917Z',
  'West Kensington':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/west_kensington_8e9d52d004.jpeg?updated_at=2023-04-07T17:24:18.757Z',
  Barbican:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/barbican_39c1997171.jpeg?updated_at=2023-04-07T17:24:10.268ZZ',
  Farringdon:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/farringdon_c51eb6bd64.jpeg?updated_at=2023-04-07T17:24:20.482Z',
  'Old Street':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/old_street_2d7a350a6a.jpeg?updated_at=2023-04-07T17:24:19.067Z',
  Shoreditch:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/shoreditch_fa92015225.jpeg?updated_at=2023-04-07T17:23:53.409Z',
  'Liverpool Street':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/liverpool_street_96832a8c04.jpeg?updated_at=2023-04-07T17:24:12.957Z',
  'The City':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/The_City_27518ccf7d.jpeg?updated_at=2023-04-07T17:22:06.175Z',
  Aldgate:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Aldgate_East_4450b4118d.jpeg?updated_at=2023-04-07T17:21:59.249ZA',
  'Fenchurch St':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Fenchurch_Street_659a50623e.jpeg?updated_at=2023-04-07T17:24:23.731Z',
  'Tower Bridge':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Tower_Bridge_e34b963ffe.jpeg?updated_at=2023-04-07T17:21:57.076Z',
  'Leadenhall Market':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Leadenhall_Mkt_d03e4075cc.jpg?updated_at=2023-04-07T17:21:57.378Z',
  "St Paul's":
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/St_Paul_s_a56e163c4a.jpg?updated_at=2023-04-07T17:22:16.293Z',
  Bank: 'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Bank_9f8d44a8bc.jpeg?updated_at=2023-04-07T17:22:05.522Z',
  'Millennium Bridge':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Millenium_Bridge_db413d991f.jpg?updated_at=2023-04-07T17:22:17.331Z',
  Blackfriars:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Blackfriars_70fd349123.jpeg?updated_at=2023-04-07T17:21:40.980Z',
  "King's Cross":
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/King_s_Cross_edf0a5048c.jpeg?updated_at=2023-04-07T17:21:55.546Z',
  "St James's":
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/st_james_s_96ceea06d7.jpeg?updated_at=2023-04-07T17:21:58.632Z',
  Westminster:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Westminster_9646159dff.jpeg?updated_at=2023-04-07T17:21:51.591Z',
  Pimlico:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Pimlico_e91deb0c7f.jpeg?updated_at=2023-04-07T17:22:00.608Z',
  Victoria:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/victoria_5938b50edd.jpeg?updated_at=2023-04-07T17:21:59.494Z',
  Belgravia:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Belgravia_7fbd127986.jpg?updated_at=2023-04-07T17:21:36.956Z',
  Marylebone:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Marylebone_9f91f212f5.jpeg?updated_at=2023-04-07T17:20:51.211Z',
  'Oxford Circus':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Oxford_circus_49d79d6dfd.jpeg?updated_at=2023-04-07T17:21:31.730Z',
  'Bond Street':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/bond_street_efb6d02635.jpeg?updated_at=2023-04-07T17:20:49.638Z',
  Chinatown:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Chinatown_ec55c151e4.jpg?updated_at=2023-04-07T17:21:26.616Z',
  Soho: 'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Soho_22c1f4b6f2.jpeg?updated_at=2023-04-07T17:21:47.353Z',
  Fitzrovia:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Fitzrovia_3ec88884c4.jpeg?updated_at=2023-04-07T17:21:28.702Z',
  Mayfair:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Mayfair_736a658ea1.jpeg?updated_at=2023-04-07T17:22:13.832Z',
  'University of London':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/uni_of_london_e851b283a1.jpeg?updated_at=2023-04-07T17:22:03.110Z',
  Bloomsbury:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/bloomsbury_2f953bbd5b.jpeg?updated_at=2023-04-07T17:20:39.483Z',
  'Chancery Lane':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/chancery_lane_89456a1676.jpeg?updated_at=2023-04-07T17:21:56.030Z',
  Clerkenwell:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/clerkenwell_af5d361e50.jpeg?updated_at=2023-04-07T17:21:56.261Z',
  Holborn:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Holborn_d8d1657755.jpeg?updated_at=2023-04-07T17:21:39.130Z',
  'The Strand':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/the_strand_9be194eac8.jpeg?updated_at=2023-04-07T17:20:43.904Z',
  'Covent Garden':
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/Covent_Garden_617820a8ab.jpeg?updated_at=2023-04-07T17:21:51.527Z',

  Temple:
    'https://cdn.gadderapp.com:9000/api.gadderapp.com/strapi/temple_740c8c3599.jpeg?updated_at=2023-04-07T17:20:33.115Z',
};

const LondonPostCodeDecryption = {
  E1: 'Spitalfields',
  E1W: "St Katharine's & Wapping",
  E2: 'Bethnal Green',
  E3: 'Bow',
  E4: 'Chingford',
  E5: 'Clapton',
  E6: 'East Ham',
  E7: 'Forest Gate',
  E8: 'Hackney',
  E9: 'Homerton',
  E10: 'Leyton',
  E11: 'Leytonstone',
  E12: 'Manor Park',
  E13: 'Plaistow',
  E14: 'Canary Wharf',
  E15: 'Stratford',
  E16: 'Victoria Docks and North Woolwich',
  E17: 'Walthamstow',
  E18: 'Woodford and South Woodford',
  E20: 'Olympic Park',
  EC2: 'Bishopsgate',
  EC3: 'Fenchurch Street',
  EC4: 'Fleet Street',
  N1: 'Islington',
  N2: 'East Finchley',
  N3: 'Finchley',
  N4: 'Finsbury Park',
  N5: 'Highbury',
  N6: 'Highgate',
  N7: 'Holloway',
  N8: 'Hornsey',
  N9: 'Lower Edmonton',
  N10: 'Muswell Hill',
  N11: 'New Southgate',
  N12: 'North Finchley',
  N13: 'Palmers Green',
  N14: 'Southgate',
  N15: 'South Tottenham',
  N16: 'Stoke Newington',
  N17: 'Tottenham',
  N18: 'Upper Edmonton',
  N19: 'Upper Holloway',
  N20: 'Whetstone',
  N21: 'Winchmore Hill',
  N22: 'Wood Green',
  NW1: 'Camden Town',
  NW2: 'Cricklewood',
  NW3: 'Hampstead',
  NW4: 'Hendon',
  NW5: 'Kentish Town',
  NW6: 'Kilburn',
  NW7: 'Mill Hill',
  NW8: "St John's Wood",
  NW9: 'The Hyde',
  NW10: 'Willesden',
  NW11: 'Golders Green',
  SE1: 'Elephant and Castle',
  SE2: 'Abbey Wood',
  SE3: 'Blackheath',
  SE4: 'Brockley',
  SE5: 'Camberwell',
  SE6: 'Catford',
  SE7: 'Charlton',
  SE8: 'Deptford',
  SE9: 'Eltham',
  SE10: 'Greenwich',
  SE11: 'Kennington',
  SE12: 'Lee',
  SE13: 'Lewisham',
  SE14: 'New Cross',
  SE15: 'Peckham',
  SE16: 'Rotherhithe',
  SE17: 'Walworth',
  SE18: 'Woolwich',
  SE19: 'Norwood',
  SE20: 'Anerley',
  SE21: 'Dulwich',
  SE22: 'East Dulwich',
  SE23: 'Forest Hill',
  SE24: 'Herne Hill',
  SE25: 'South Norwood',
  SE26: 'Sydenham',
  SE27: 'West Norwood',
  SE28: 'Thamesmead',
  SW1: 'Chelsea',
  SW2: 'Brixton',
  SW3: 'Chelsea',
  SW4: 'Clapham',
  SW5: 'Earls Court',
  SW6: 'Fulham',
  SW7: 'South Kensington',
  SW8: 'South Lambeth',
  SW9: 'Brixton',
  SW10: 'West Brompton',
  SW11: 'Clapham',
  SW12: 'Balham',
  SW13: 'Barnes',
  SW14: 'Mortlake',
  SW15: 'Putney',
  SW16: 'Streatham',
  SW17: 'Tooting',
  SW18: 'Wandsworth',
  SW19: 'Wimbledon',
  SW20: 'West Wimbledon',
  W2: 'Paddington',
  W3: 'Acton',
  W4: 'Chiswick',
  W5: 'Ealing',
  W6: 'Hammersmith',
  W7: 'Hanwell',
  W8: 'Kensington',
  W9: 'Maida Hill',
  W10: 'North Kensington',
  W11: 'Notting Hill',
  W12: 'Shepherds Bush',
  W13: 'West Ealing',
  W14: 'West Kensington',
  EC1A: 'Barbican',
  EC1M: 'Farringdon',
  EC1N: 'Farringdon',
  EC1R: 'Clerkenwell',
  EC1V: 'Old Street',
  EC1Y: 'Shoreditch',
  EC2A: 'Shoreditch',
  EC2M: 'Liverpool Street',
  EC2N: 'Bishopsgate',
  EC2R: 'Bank',
  EC2V: 'The City',
  EC2Y: 'Barbican',
  EC3A: 'Aldgate',
  EC3M: 'Fenchurch St',
  EC3N: 'Tower Bridge',
  EC3R: 'Tower Bridge',
  EC3V: 'Leadenhall Market',
  EC4A: 'The City',
  EC4M: "St Paul's",
  EC4N: 'Bank',
  EC4R: 'The City',
  EC4V: 'Millennium Bridge',
  EC4Y: 'Blackfriars',
  N1C: "King's Cross",
  SW1A: "St James's",
  SW1E: 'Westminster',
  SW1H: 'Westminster',
  SW1P: 'Westminster',
  SW1V: 'Pimlico',
  SW1W: 'Victoria',
  SW1X: 'Belgravia',
  SW1Y: "St James's",
  W1A: 'Marylebone',
  W1B: 'Oxford Circus',
  W1C: 'Bond Street',
  W1D: 'Chinatown',
  W1F: 'Soho',
  W1G: 'Fitzrovia',
  W1H: 'Marylebone',
  W1J: 'Mayfair',
  W1K: 'Mayfair',
  W1S: 'Mayfair',
  W1T: 'Fitzrovia',
  W1U: 'Marylebone',
  W1W: 'Fitzrovia',
  WC1A: 'Holborn',
  WC1B: 'Holborn',
  WC1E: 'University of London',
  WC1H: 'Saint Pancras',
  WC1N: 'Bloomsbury',
  WC1R: 'Holborn',
  WC1V: 'Chancery Lane',
  WC1X: 'Clerkenwell',
  WC2A: 'Holborn',
  WC2B: 'The Strand',
  WC2E: 'Covent Garden',
  WC2H: 'Covent Garden',
  WC2N: 'Embankment',
  WC2R: 'Temple',
};

export const useDistrict = (
  lat?: number,
  lng?: number,
): [string | null, boolean, any] => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setError] = useState<any>(null);
  const [district, setDistrict] = useState<null | string>(null);

  useEffect(() => {
    if (lat && lng) {
      setIsLoading(true);
      axios
        .post(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat.toFixed(
            3,
          )},${lng.toFixed(
            3,
          )}&location_type=ROOFTOP|RANGE_INTERPOLATED&key=${GOOGLE_API_KEY}`,
        )
        .then(response => {
          setIsLoading(false);

          const postCodes = response.data.results
            .map(_addres =>
              _addres.address_components.find(_component =>
                _component.types.find(
                  _type =>
                    _type === 'postal_code' || _type === 'postal_code_prefix',
                ),
              ),
            )
            .map(_post_code => _post_code.long_name.split(' ')[0]);

          setDistrict(
            postCodes.length > 0
              ? LondonPostCodeDecryption[postCodes[0]]
              : null,
          );
        })
        .catch(error => {
          setIsLoading(false);
          setError(error);
        });
    }
  }, [lat, lng]);

  return [district, isLoading, isError];
};
